import { render, staticRenderFns } from "./right-panel.vue?vue&type=template&id=2daef4fa"
import script from "./right-panel.vue?vue&type=script&lang=js"
export * from "./right-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports